module.exports = __webpack_public_path__ + "img/3.432c5c1a.png";